var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArticlesOutlined(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.9175 10.35H10.98V9H5.9175V10.35ZM5.9175 8.325H14.805V6.975H5.9175V8.325ZM5.9175 6.3H14.805V4.95H5.9175V6.3ZM4.05 15.3C3.69 15.3 3.375 15.165 3.105 14.895C2.835 14.625 2.7 14.31 2.7 13.95V1.35C2.7 0.99 2.835 0.675 3.105 0.405C3.375 0.135 3.69 0 4.05 0H16.65C17.01 0 17.325 0.135 17.595 0.405C17.865 0.675 18 0.99 18 1.35V13.95C18 14.31 17.865 14.625 17.595 14.895C17.325 15.165 17.01 15.3 16.65 15.3H4.05ZM4.05 13.95H16.65V1.35H4.05V13.95ZM1.35 18C0.99 18 0.675 17.865 0.405 17.595C0.135 17.325 0 17.01 0 16.65V2.7H1.35V16.65H15.3V18H1.35Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArticlesOutlined);
export default __webpack_public_path__ + "static/media/articles-outlined.71a2223c.svg";
export { ForwardRef as ReactComponent };